export default [
    {
        name: 'Not set',
        id: 0
    },
    {
        name: 'Locksmith',
        id: 1
    },
    {
        name: 'On-Demand Repair',
        id: 2
    },
    {
        name: 'Online Gambling',
        id: 3
    },
    {
        name: 'Plumbing',
        id: 4
    },
    {
        name: 'Realty',
        id: 5
    },
    {
        name: 'Financial Services',
        id: 6
    },
    {
        name: 'Moving/Storage',
        id: 7
    },
    {
        name: 'E-commerce',
        id: 8
    },
    {
        name: 'Travel',
        id: 9
    },
    {
        name: 'Consulting',
        id: 10
    },
    {
        name: 'Law / Legal',
        id: 11
    },
    {
        name: 'Education',
        id: 12
    },
    {
        name: 'Automotive',
        id: 13
    },
    {
        name: 'Marketing',
        id: 14
    },
    {
        name: 'Computer Services',
        id: 15
    },
    {
        name: 'Sports/Fitness',
        id: 16
    },
    {
        name: 'Homecare',
        id: 17
    },
    {
        name: 'Healthcare',
        id: 18
    },
    {
        name: 'Electrician',
        id: 19
    },
    {
        name: 'Loans',
        id: 20
    },
    {
        name: 'Media',
        id: 21
    },
    {
        name: 'Advertising',
        id: 22
    },
    {
        name: 'Transport',
        id: 23
    },
    {
        name: 'Retail',
        id: 24
    },
    {
        name: 'Waste Removal',
        id: 25
    },
    {
        name: 'Insurance',
        id: 26
    },
    {
        name: 'Regulation',
        id: 27
    },
    {
        name: 'Maintenance',
        id: 28
    },
    {
        name: 'Telecommunications',
        id: 30
    },
    {
        name: 'Software',
        id: 31
    },
    {
        name: 'Utilities',
        id: 32
    },
    {
        name: 'Dumpster Rental',
        id: 33
    },
    {
        name: 'Pest Control',
        id: 34
    },
    {
        name: 'Entertainment',
        id: 35
    },
    {
        name: 'Photography',
        id: 36
    },
    {
        name: 'Addiction Treatment',
        id: 37
    },
    {
        name: 'HVAC',
        id: 38
    },
    {
        name: 'Pet Services',
        id: 39
    },
    {
        name: 'Beauty',
        id: 40
    },
    {
        name: 'Food',
        id: 41
    },
    {
        name: 'Driving School',
        id: 42
    }
];
